"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _uiBox = _interopRequireDefault(require("ui-box"));

var OrderedList =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(OrderedList, _PureComponent);

  function OrderedList() {
    (0, _classCallCheck2.default)(this, OrderedList);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(OrderedList).apply(this, arguments));
  }

  (0, _createClass2.default)(OrderedList, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          size = _this$props.size,
          props = (0, _objectWithoutProperties2.default)(_this$props, ["children", "size"]);

      var finalChildren = _react.default.Children.map(children, function (child) {
        if (!_react.default.isValidElement(child)) {
          return child;
        }

        return _react.default.cloneElement(child, {
          // Prefer more granularly defined icon if present
          size: child.props.size || size
        });
      });

      return _react.default.createElement(_uiBox.default, (0, _extends2.default)({}, OrderedList.styles, props), finalChildren);
    }
  }]);
  return OrderedList;
}(_react.PureComponent);

exports.default = OrderedList;
OrderedList.displayName = "OrderedList";
(0, _defineProperty2.default)(OrderedList, "propTypes", (0, _objectSpread2.default)({}, _uiBox.default.propTypes, {
  /**
   * Size of the text used in a list item.
   * Can be: 300, 400, 500, 600.
   */
  size: _propTypes.default.oneOf([300, 400, 500, 600]).isRequired
}));
(0, _defineProperty2.default)(OrderedList, "defaultProps", {
  size: 400
});
(0, _defineProperty2.default)(OrderedList, "styles", {
  is: 'ol',
  margin: 0,
  marginLeft: '1.1em',
  padding: 0,
  listStylePosition: 'inside',
  listStyle: 'decimal'
});
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy90eXBvZ3JhcGh5L3NyYy9PcmRlcmVkTGlzdC5qcyJdLCJuYW1lcyI6WyJPcmRlcmVkTGlzdCIsInByb3BzIiwiY2hpbGRyZW4iLCJzaXplIiwiZmluYWxDaGlsZHJlbiIsIlJlYWN0IiwiQ2hpbGRyZW4iLCJtYXAiLCJjaGlsZCIsImlzVmFsaWRFbGVtZW50IiwiY2xvbmVFbGVtZW50Iiwic3R5bGVzIiwiUHVyZUNvbXBvbmVudCIsIkJveCIsInByb3BUeXBlcyIsIlByb3BUeXBlcyIsIm9uZU9mIiwiaXNSZXF1aXJlZCIsImlzIiwibWFyZ2luIiwibWFyZ2luTGVmdCIsInBhZGRpbmciLCJsaXN0U3R5bGVQb3NpdGlvbiIsImxpc3RTdHlsZSJdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7QUFBQTs7QUFDQTs7QUFDQTs7SUFFcUJBLFc7Ozs7Ozs7Ozs7Ozs2QkF3QlY7QUFBQSx3QkFDOEIsS0FBS0MsS0FEbkM7QUFBQSxVQUNDQyxRQURELGVBQ0NBLFFBREQ7QUFBQSxVQUNXQyxJQURYLGVBQ1dBLElBRFg7QUFBQSxVQUNvQkYsS0FEcEI7O0FBR1AsVUFBTUcsYUFBYSxHQUFHQyxlQUFNQyxRQUFOLENBQWVDLEdBQWYsQ0FBbUJMLFFBQW5CLEVBQTZCLFVBQUFNLEtBQUssRUFBSTtBQUMxRCxZQUFJLENBQUNILGVBQU1JLGNBQU4sQ0FBcUJELEtBQXJCLENBQUwsRUFBa0M7QUFDaEMsaUJBQU9BLEtBQVA7QUFDRDs7QUFFRCxlQUFPSCxlQUFNSyxZQUFOLENBQW1CRixLQUFuQixFQUEwQjtBQUMvQjtBQUNBTCxVQUFBQSxJQUFJLEVBQUVLLEtBQUssQ0FBQ1AsS0FBTixDQUFZRSxJQUFaLElBQW9CQTtBQUZLLFNBQTFCLENBQVA7QUFJRCxPQVRxQixDQUF0Qjs7QUFXQSxhQUNFLDZCQUFDLGNBQUQsNkJBQVNILFdBQVcsQ0FBQ1csTUFBckIsRUFBaUNWLEtBQWpDLEdBQ0dHLGFBREgsQ0FERjtBQUtEOzs7RUEzQ3NDUSxvQjs7O0FBQXBCWixXOzhCQUFBQSxXLCtDQUVkYSxlQUFJQyxTO0FBRVA7Ozs7QUFJQVgsRUFBQUEsSUFBSSxFQUFFWSxtQkFBVUMsS0FBVixDQUFnQixDQUFDLEdBQUQsRUFBTSxHQUFOLEVBQVcsR0FBWCxFQUFnQixHQUFoQixDQUFoQixFQUFzQ0M7OzhCQVIzQmpCLFcsa0JBV0c7QUFDcEJHLEVBQUFBLElBQUksRUFBRTtBQURjLEM7OEJBWEhILFcsWUFlSDtBQUNka0IsRUFBQUEsRUFBRSxFQUFFLElBRFU7QUFFZEMsRUFBQUEsTUFBTSxFQUFFLENBRk07QUFHZEMsRUFBQUEsVUFBVSxFQUFFLE9BSEU7QUFJZEMsRUFBQUEsT0FBTyxFQUFFLENBSks7QUFLZEMsRUFBQUEsaUJBQWlCLEVBQUUsUUFMTDtBQU1kQyxFQUFBQSxTQUFTLEVBQUU7QUFORyxDIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0LCB7IFB1cmVDb21wb25lbnQgfSBmcm9tICdyZWFjdCdcbmltcG9ydCBQcm9wVHlwZXMgZnJvbSAncHJvcC10eXBlcydcbmltcG9ydCBCb3ggZnJvbSAndWktYm94J1xuXG5leHBvcnQgZGVmYXVsdCBjbGFzcyBPcmRlcmVkTGlzdCBleHRlbmRzIFB1cmVDb21wb25lbnQge1xuICBzdGF0aWMgcHJvcFR5cGVzID0ge1xuICAgIC4uLkJveC5wcm9wVHlwZXMsXG5cbiAgICAvKipcbiAgICAgKiBTaXplIG9mIHRoZSB0ZXh0IHVzZWQgaW4gYSBsaXN0IGl0ZW0uXG4gICAgICogQ2FuIGJlOiAzMDAsIDQwMCwgNTAwLCA2MDAuXG4gICAgICovXG4gICAgc2l6ZTogUHJvcFR5cGVzLm9uZU9mKFszMDAsIDQwMCwgNTAwLCA2MDBdKS5pc1JlcXVpcmVkXG4gIH1cblxuICBzdGF0aWMgZGVmYXVsdFByb3BzID0ge1xuICAgIHNpemU6IDQwMFxuICB9XG5cbiAgc3RhdGljIHN0eWxlcyA9IHtcbiAgICBpczogJ29sJyxcbiAgICBtYXJnaW46IDAsXG4gICAgbWFyZ2luTGVmdDogJzEuMWVtJyxcbiAgICBwYWRkaW5nOiAwLFxuICAgIGxpc3RTdHlsZVBvc2l0aW9uOiAnaW5zaWRlJyxcbiAgICBsaXN0U3R5bGU6ICdkZWNpbWFsJ1xuICB9XG5cbiAgcmVuZGVyKCkge1xuICAgIGNvbnN0IHsgY2hpbGRyZW4sIHNpemUsIC4uLnByb3BzIH0gPSB0aGlzLnByb3BzXG5cbiAgICBjb25zdCBmaW5hbENoaWxkcmVuID0gUmVhY3QuQ2hpbGRyZW4ubWFwKGNoaWxkcmVuLCBjaGlsZCA9PiB7XG4gICAgICBpZiAoIVJlYWN0LmlzVmFsaWRFbGVtZW50KGNoaWxkKSkge1xuICAgICAgICByZXR1cm4gY2hpbGRcbiAgICAgIH1cblxuICAgICAgcmV0dXJuIFJlYWN0LmNsb25lRWxlbWVudChjaGlsZCwge1xuICAgICAgICAvLyBQcmVmZXIgbW9yZSBncmFudWxhcmx5IGRlZmluZWQgaWNvbiBpZiBwcmVzZW50XG4gICAgICAgIHNpemU6IGNoaWxkLnByb3BzLnNpemUgfHwgc2l6ZVxuICAgICAgfSlcbiAgICB9KVxuXG4gICAgcmV0dXJuIChcbiAgICAgIDxCb3ggey4uLk9yZGVyZWRMaXN0LnN0eWxlc30gey4uLnByb3BzfT5cbiAgICAgICAge2ZpbmFsQ2hpbGRyZW59XG4gICAgICA8L0JveD5cbiAgICApXG4gIH1cbn1cbiJdfQ==


//////////////////
// WEBPACK FOOTER
// ./~/evergreen-ui/commonjs/typography/src/OrderedList.js
// module id = 273
// module chunks = 0